import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyle = createGlobalStyle`
    ${reset}
    *{
        padding: 0px;
        margin: 0px;
        box-sizing: border-box;
        border: 0px;
    }
    body{
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        font-size: 14px;
        background-color: rgba(20, 20, 20, 1);
        color: white;
        background: white;
    }
    a{
        text-decoration: none;
        color: inherit;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
    }
    input,button{
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
    }
    ol,ul,li{
        list-style: none;
    }
    img{
        display: block;
        width: 100%;
        height: 100%;
    }
`;

export default GlobalStyle;